import { nullSafeGetOrElse, safeJSONParseOrElse } from '../../../utils/DataAccessUtils';
import { AuditChangeElementProps } from './AuditChangeComponent';

export const getAuditDiffForJsonValue = (field): AuditChangeElementProps[] => {
	const oldValue = field.oldValue || '[]';
	const newValue = field.newValue || '[]';

	const oldValuesJson = safeJSONParseOrElse(oldValue, []);
	const newValuesJson = safeJSONParseOrElse(newValue, []);

	const allKeys = new Set([
		...oldValuesJson.map((entry) => entry.key),
		...newValuesJson.map((entry) => entry.key),
	]);

	return Array.from(allKeys)
		.map((key) => {
			const oldItem = oldValuesJson.find((entry) => entry.key === key);
			const newItem = newValuesJson.find((entry) => entry.key === key);

			return {
				resolvedFieldName: key,
				fieldName: key,
				resolvedOldValue: nullSafeGetOrElse('valueAsString', oldItem, ''),
				oldValue: nullSafeGetOrElse('valueAsString', oldItem, ''),
				resolvedNewValue: nullSafeGetOrElse('valueAsString', newItem, ''),
				newValue: nullSafeGetOrElse('valueAsString', newItem, ''),
			};
		})
		.filter((change) => change.resolvedOldValue !== change.resolvedNewValue);
};
